import * as React from 'react';

import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';

import { CoordinationCard } from 'data/models/CoordinationCard';

import {
    AddPortCallReviewTab as ReviewTab,
    BatchRequestViewModel,
    CoordinationCardViewModel,
    ReviewTabMilestone
} from './review';

import {
    BerthStayDurationText,
    MetroMapFrameworkView,
    MilestoneHeaderRow,
    MilestoneScheduleDetailsRow
} from 'portcall/metromapframework/view';
import { InPortOpsSummaryText, PortCallScheduleHeaderView } from 'portcall/portcallschedule/view';

import { frequencyDescriptionText } from './itineraryview';

export const AddPortCallReviewTabView = SuperCritical(({ model: m } : { model : ReviewTab }) =>
    <div className="addportcallreviewtab">
        <PortCallScheduleHeaderView className="schedule-header" model={m.ScheduleHeader} />
        <ScheduleView model={m} />
        {/* TODO: Info about PJOs? */}
        <RepetitionInfo model={m} />
    </div>
);

const ScheduleView = SuperCritical(({ model: m } : { model : ReviewTab }) =>
    <div className="schedule">
        <MetroMapFrameworkView
            model={m.Framework}
            ctrl={{ milestoneContent: m => <MilestoneContent milestone={m} /> }}
        />
    </div>
);

const MilestoneContent = SuperCritical(({ milestone: m } : { milestone : ReviewTabMilestone }) =>
    <div>
        <MilestoneHeaderRow milestone={m} />
        <MilestoneScheduleDetailsRow milestone={m} />
        <MilestoneCoordinationsRow milestone={m} />
    </div>
);

const MilestoneCoordinationsRow = SuperCritical(({ milestone: m } : { milestone : ReviewTabMilestone }) =>
    <div className="portcall-milestone-row coordinations-row">
        <div className="portcall-milestone-row-label">
            {m.Date.IsBerthArrivalDate() && BerthStayDurationText(m)}
        </div>
        <div className="portcall-milestone-row-body">
            {m.Date.IsBerthArrivalDate() && <BerthAssignmentView milestone={m} />}
            {m.CoordinationCards().map(ccard =>
                <CCardView ccard={ccard} key={CCardKey(ccard)} />
            )}
        </div>
    </div>
);

const BerthAssignmentView = SuperCritical(({ milestone: m } : { milestone : ReviewTabMilestone }) =>
    <div className="coordination-card">
        <div className="header">
            <span className="coordination-title">Berth Assignment</span>
        </div>
        <div className="pc-text-smalllabel description">
            {m.Date.ItineraryPoint()?.BerthReservation() &&
                InPortOpsSummaryText(m.Date.ItineraryPoint()!.BerthReservation()!)
            }
        </div>
    </div>
        
);

let nextCCardKey = 0;
const CCARD_KEYS = new WeakMap<CoordinationCard, number>();
function CCardKey(ccard : CoordinationCardViewModel) {
    let id = CCARD_KEYS.get(ccard.Model);
    if (id === undefined) {
        id = nextCCardKey++;
        CCARD_KEYS.set(ccard.Model, id);
    }
    return id;
}

const CCardView = SuperCritical(({ ccard } : { ccard : CoordinationCardViewModel }) =>
    <div className="coordination-card">
        <div className="header">
            <span className="coordination-title">{ccard.Model.Coordination()?.Title()}</span>
            <span className="coordination-title-separator">|</span>
            <span className="coordination-provider">{ccard.Model.Provider()?.Provider()?.Name()}</span>
        </div>
        <div className="pc-text-smalllabel description">{ccard.Model.Coordination()?.Description()}</div>
    </div>
);

const RepetitionInfo = SuperCritical(({ model: m } : { model : ReviewTab }) =>
    m.BatchRequest() ?
        <RepeatedPortCall batchReq={m.BatchRequest()!} /> :
        <div className="repetition-info is-not-repeated">
            This PortCall is not repeated.
        </div>
);

const BATCH_DATES_FORMAT = 'HH:mm on DD MMM YYYY';

const RepeatedPortCall = SuperCritical(({ batchReq: b } : { batchReq : BatchRequestViewModel }) => {
    const
        batch = b.Model.Batch(),
        preview = b.Preview();
    return (
        <div className="repetition-info is-repeated">
            <div className="header">Range</div>
            <div className="batch-info-row">
                <label className="batch-info-label">Frequency</label>
                <span className="batch-info-body">
                    {batch && frequencyDescriptionText(b.StartDate(), batch.RecurrencePeriod)}
                </span>
            </div>
            <div className="batch-info-row">
                <label className="batch-info-label">Batch Size</label>
                <span className="batch-info-body">
                    {preview && `${preview.BatchSize} ${preview.BatchSize === 1 ? 'PortCall' : 'PortCalls'}`}
                </span>
            </div>
            <div className="batch-info-row">
                <label className="batch-info-label">First PortCall Arrival</label>
                <span className="batch-info-body">
                    {preview?.FirstPortCallArrival && tzmoment(preview.FirstPortCallArrival).format(BATCH_DATES_FORMAT)}
                </span>
            </div>
            <div className="batch-info-row">
                <label className="batch-info-label">Last PortCall Arrival</label>
                <span className="batch-info-body">
                    {preview?.LastPortCallArrival && tzmoment(preview.LastPortCallArrival).format(BATCH_DATES_FORMAT)}
                </span>
            </div>
        </div>
    );
});



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/reviewview.tsx